const HTTP_CODE_STATUS = {
  /**40001未登录 40002token失效 40010账号被异地登录 40011token来源异常*/
  INVALID: [40001, 40002, 40010, 40011],
  /**成功状态 */
  SUCCESS: 1,
  /**上传成功 */
  JTS_UPLOAD_SUCCESS: 307,
  /**部分上传失败或全部上传失败 */
  JTS_UPLOAD_PART_SUCCESS: 308,
  /**请求参数为空 */
  JTS_PARAM_NULL: 9999,
  /**记录未找到 */
  JTS_RECORDS_NULL: 20002,
  /**系统错误 */
  JTS_SYS_ERROR: 70000,

  /**查詢成功 */
  JTS_SUCCESS: 20000,
  /**成功 */
  JTS_SUCCESS_CONFIRM: 60000,

  /**返回时间状态 */
  TIME_BACK_STATUS: 50023,

  /**jts快递员未绑定 */
  JTS_EMP_UN_BIND: [4059, 4105, 4111, 6030, 100000043]
}
export default Object.freeze(HTTP_CODE_STATUS)
